export default __webpack_public_path__ + "static/media/fdp (2).ced8d400.jpeg";